export default [
    {
        version : "3.0.5",
        date : "2024-12-24",
        log : [
            "头部表单组件新增 slot 插槽",
            "表单组件新增 slot 默认插槽 form-header 具名插槽",
            "上传文件/图片组件 新增 uploadFun 属性 可以自定义上传方法",
            "修复日期转农历 农历年跨年不对的bug"
        ]
    },
    {
        version : "3.0.4",
        date : "2024-10-31",
        log : [
            "修复表单组件在v-model下 有更多值不会携带出来的bug",
        ]
    },
    {
        version : "3.0.3",
        date : "2024-10-16",
        log : [
            "修复表单组件在v-model小概率赋值失败的bug",
            "优化表单组件/表单组件的参数提示",
            "修复表单组织某些情况下下拉框、多选框、单选框value值相同时报key不是唯一值的bug"
        ]
    },
    {
        version : "3.0.2",
        date : "2024-09-10",
        log : [
            "修复搜索表单组件/表单组件在v-model多层级(xx.xx.xx)赋值失败的bug",
            "参数提示表格对参数类型进行了优化处理"
        ]
    },
    {
        version : "3.0.1",
        date : "2024-08-12",
        log : [
            "修复搜索表单组件/表单组件没填写props报错的bug",
            "修复代码编辑器不能输入的bug",
            "新增后台代码四件套 地址 /four-sets",
            "优化了 富文本编辑器 在后端插入sql时单引号出现的bug"
        ]
    },
    {
        version : "3.0.0",
        date : "2024-08-06",
        log : [
            "全新版本上线了",
            "新增代码编辑器组件",
            "新增文件上传组件、图片上传组件",
            "文档预览新增ppt、txt",
            "删除了拖动示例",
            "搜索更改了 请用ctrl+k进行搜索",
            "优化了暂开指令 修复了部分失效的bug",
            "修复了部分bug"
        ]
    },
]